<template>
  <div class="d-flex justify-content-between m-b-50">
    <h3 class="title black-1 mb-0">
      <span class="header-letter-first blue">{{ titleFirstLetter }}</span>
      <span class="header-letter">{{ titleLetters }}</span>
    </h3>
    <div>
      <i
        :class="card.icon"
        class="f-s-30"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardHeadingWithIcon',
  props: {
    card: {
      type: Object,
      default: null,
    },
  },
  computed: {
    titleFirstLetter() {
      return this.card?.title?.[0];
    },
    titleLetters() {
      return this.card?.title?.substring(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  min-width: 120px;
  font-size: 18px;
  padding: 0 !important;
  letter-spacing: 0.175em;
  position: relative;

  .header-letter {
    position: absolute;
    bottom: -3px;
    left: 20px;

    &-first {
      font-size: 24px !important;
      border-bottom: 3px solid #d7e3fc;
    }
  }
}
</style>
